<div class="h-100 single-report-page">
    <app-admin-report [columns]="zonesFromReport" [hasFilters]="true" [apiUrl]="zonesFromReportAPI"
                      reportTitle="ADMINISTRATION.ZONE_FROM_PACKAGES_SUMMARY_REPORT_TITLE">
    </app-admin-report>
</div>